// src/pages/TermsOfService.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, ArrowLeft } from 'lucide-react';

const sections = [
  { id: 1, title: '第1条（適用）', content: '本利用規約（以下「本規約」）は、富永コーチングカントリークラブ株式会社（以下「当社」）が提供するサービス「NOBISHIROコンピテンシー®」（以下「本サービス」）の利用条件を定めるものです。登録ユーザーの皆さま（以下「ユーザー」）には、本規約に従って本サービスをご利用いただきます。' },
  { id: 2, title: '第2条（利用登録）', content: '本サービスにおいては、登録希望者が本規約に同意の上、当社の定める方法によって利用登録を申請し、当社がこれを承認することによって、利用登録が完了するものとします。\n\n当社は、利用登録の申請者に以下の事由があると判断した場合、利用登録の申請を承認しないことがあります。\n\n・本規約に違反したことがある者からの申請である場合\n・その他、当社が利用登録を相当でないと判断した場合' },
  { id: 3, title: '第3条（ユーザーIDおよびパスワードの管理）', content: 'ユーザーは、自己の責任において、本サービスのユーザーIDおよびパスワードを適切に管理するものとします。ユーザーは、いかなる場合にも、ユーザーIDおよびパスワードを第三者に譲渡または貸与し、もしくは第三者と共用することはできません。' },
  { id: 4, title: '第4条（利用料金および支払方法）', content: 'ユーザーは、本サービスの有料部分の対価として、当社が別途定め、本サービス上に表示する利用料金を、当社が指定する方法により支払うものとします。\n\n・Student プラン：¥480／月\n・Standard プラン：¥980／月\n・Business プラン：¥4,980／月' },
  { id: 5, title: '第5条（禁止事項）', content: 'ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。\n\n・法令または公序良俗に違反する行為\n・犯罪行為に関連する行為\n・当社のサービスの運営を妨害するおそれのある行為\n・不正アクセスをし、またはこれを試みる行為\n・その他、当社が不適切と判断する行為' },
  { id: 6, title: '第6条（本サービスの提供の停止等）', content: '当社は、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。\n\n・システムの保守点検または更新を行う場合\n・天災などの不可抗力により提供が困難となった場合' },
  { id: 7, title: '第7条（免責事項）', content: '当社の債務不履行責任は、当社の故意または重過失によらない場合には免責されるものとします。当社は、本サービスに関して、ユーザーと他のユーザーまたは第三者との間において生じた取引、連絡または紛争等について一切責任を負いません。' },
  { id: 8, title: '第8条（利用規約の変更）', content: '当社は、必要と判断した場合には、ユーザーに通知することなくいつでも本規約を変更することができるものとします。本規約の変更後、本サービスの利用を開始した場合には、当該ユーザーは変更後の規約に同意したものとみなします。' },
  { id: 9, title: '第9条（準拠法・裁判管轄）', content: '本規約の解釈にあたっては、日本法を準拠法とします。本サービスに関して紛争が生じた場合には、当社の本店所在地を管轄する裁判所を専属的合意管轄とします。' },
];

const AccordionItem = ({ section, isOpen, onToggle }) => (
  <div className="border-b border-white/10">
    <button onClick={onToggle} className="w-full flex items-center justify-between py-5 px-6 text-left hover:bg-white/5 transition-colors group">
      <span className="text-sm font-medium text-white/90 group-hover:text-amber-400 transition-colors">{section.title}</span>
      <ChevronDown className={`w-4 h-4 text-amber-400 flex-shrink-0 ml-4 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} />
    </button>
    <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96' : 'max-h-0'}`}>
      <div className="px-6 pb-5"><p className="text-sm text-white/60 leading-relaxed whitespace-pre-line">{section.content}</p></div>
    </div>
  </div>
);

const TermsOfService = () => {
  const [openId, setOpenId] = useState(null);
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <div className="border-b border-white/10">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/dashboard" className="flex items-center gap-2 text-white/50 hover:text-white transition-colors text-sm"><ArrowLeft className="w-4 h-4" />ダッシュボードに戻る</Link>
          <span className="text-xs text-amber-400 font-medium tracking-widest uppercase">Legal</span>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-6 py-16">
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-px flex-1 bg-gradient-to-r from-transparent to-amber-400/50" />
            <span className="text-xs text-amber-400 tracking-widest uppercase font-medium">Terms of Service</span>
            <div className="h-px flex-1 bg-gradient-to-l from-transparent to-amber-400/50" />
          </div>
          <h1 className="text-3xl font-bold text-center mb-3">利用規約</h1>
          <p className="text-center text-white/40 text-sm">最終更新日：2026年3月8日</p>
        </div>
        <div className="bg-white/5 border border-white/10 rounded-xl p-6 mb-8">
          <p className="text-sm text-white/70 leading-relaxed">本利用規約は、富永コーチングカントリークラブ株式会社が提供する「NOBISHIROコンピテンシー®」の利用に関する条件を定めたものです。本サービスをご利用いただく前に、必ずお読みください。</p>
        </div>
        <div className="bg-white/5 border border-white/10 rounded-xl overflow-hidden mb-12">
          {sections.map((section) => (<AccordionItem key={section.id} section={section} isOpen={openId === section.id} onToggle={() => setOpenId(openId === section.id ? null : section.id)} />))}
        </div>
        <div className="border border-amber-400/20 rounded-xl p-6 bg-amber-400/5">
          <h3 className="text-sm font-semibold text-amber-400 mb-4 tracking-wider uppercase">事業者情報</h3>
          <dl className="space-y-2 text-sm">
            <div className="flex gap-4"><dt className="text-white/40 w-24 flex-shrink-0">事業者名</dt><dd className="text-white/80">富永コーチングカントリークラブ株式会社</dd></div>
            <div className="flex gap-4"><dt className="text-white/40 w-24 flex-shrink-0">サービス名</dt><dd className="text-white/80">NOBISHIROコンピテンシー®</dd></div>
            <div className="flex gap-4"><dt className="text-white/40 w-24 flex-shrink-0">お問い合わせ</dt><dd className="text-white/80">tominagacccyuki@gmail.com</dd></div>
          </dl>
        </div>
        <div className="mt-12 text-center">
          <Link to="/privacy" className="text-xs text-amber-400 hover:underline mr-6">プライバシーポリシー</Link>
          <Link to="/dashboard" className="text-xs text-white/40 hover:text-white transition-colors">ダッシュボードに戻る</Link>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
